import { render } from "./lrbTable3.vue?vue&type=template&id=bc422864&scoped=true"
import script from "./lrbTable3.vue?vue&type=script&lang=js"
export * from "./lrbTable3.vue?vue&type=script&lang=js"

import "./lrbTable3.vue?vue&type=style&index=0&id=bc422864&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc422864"]])

export default __exports__